module.exports = __webpack_public_path__ + "assets/img/my-vpp-btn-1.af2d8234.png";